import axios from 'axios'
export default () => {
    axios.defaults.withCredentials = true;
    axios.defaults.timeout = 5000;
    return axios.create({
        baseURL: process.env.VUE_APP_API_ENDPOINT
    })
}